import * as React from "react";

import { DATE_FORMAT } from "@impero-com/common/utils/formatting";
import { DatePicker as AntdDatePicker } from "antd";

type DatePickerProps = Omit<
    React.ComponentProps<typeof AntdDatePicker>,
    "format"
>;

class DatePicker extends React.PureComponent<DatePickerProps> {
    render = () => {
        const props = {
            format: DATE_FORMAT,
            ...this.props,
        };

        return <AntdDatePicker {...props} />;
    };
}

export { DatePicker };
